import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import { UserInteractionInstrumentation } from "@opentelemetry/instrumentation-user-interaction";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { resourceFromAttributes } from "@opentelemetry/resources";
import { BatchSpanProcessor } from "@opentelemetry/sdk-trace-base";
import { WebTracerProvider } from "@opentelemetry/sdk-trace-web";
import { ATTR_SERVICE_NAME } from "@opentelemetry/semantic-conventions";
export var initOpenTelemetry = function () {
    var _a;
    var serviceName = process.env.REACT_APP_OTEL_SERVICE_NAME || "xvia-x-forms-designer";
    var tracesEndpoint = process.env.REACT_APP_OTEL_EXPORTER_OTLP_ENDPOINT || "/v1/traces";
    var exporter = new OTLPTraceExporter({
        url: tracesEndpoint,
        headers: {},
    });
    var provider = new WebTracerProvider({
        resource: resourceFromAttributes((_a = {},
            _a[ATTR_SERVICE_NAME] = serviceName,
            _a)),
        spanProcessors: [new BatchSpanProcessor(exporter)],
    });
    provider.register();
    registerInstrumentations({
        instrumentations: [
            new DocumentLoadInstrumentation(),
            new UserInteractionInstrumentation(),
            new XMLHttpRequestInstrumentation({
                propagateTraceHeaderCorsUrls: [/.+/g],
                ignoreUrls: [/login\.demo-aws\.xvia\.com\.br/i],
            }),
            new FetchInstrumentation({
                propagateTraceHeaderCorsUrls: [/.+/g],
                ignoreUrls: [/login\.demo-aws\.xvia\.com\.br/i],
            }),
        ],
    });
};
